import * as e from "react";
import c from "../lib/IconBase.es.js";
import a from "../defs/Sticker.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(c, { ref: t, ...r, weights: a }));
o.displayName = "StickerIcon";
const s = o;
export {
  s as Sticker,
  o as StickerIcon
};
